import {AfterViewInit, Component, OnInit, ViewChild} from "@angular/core";
import {UserService} from "../../../common/service/user.service";
import {Constant} from "../../../common/constant";
import {DataService} from "../../../common/service/data.service";
import {DialogService} from "../../../common/service/dialog.service";
import {FormBuilder, NgForm, Validators} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {MenuService} from "../../../common/service/menu.service";
import {fadeInAnimation} from "../../../common/service/routerTransition";
import { ShortcutService } from "../../../common/service/shortcut.service";
import { AccountService } from '../../services/account.service';
import { CustomComponentService } from '../../services/custom-component.service';
import { Observable, Subscription } from 'rxjs';
import { Dispatcher, OpenOTP } from 'src/app/state';
import { EventManagerService } from 'src/app/common/service/event-manager.service';

/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector:"change-password",
  templateUrl : "./change-password.html",
  styleUrls: [
    './change-password.scss'
  ],
})

export class ChangePassword implements OnInit,AfterViewInit{
  public editForm = this.fb.group({
    currentPassword: ['', [Validators.required,  Validators.minLength(8), Validators.maxLength(40)]],
    newPassword: ['', [Validators.required,  Validators.minLength(8), Validators.maxLength(40)]],
    confirmPassword: ['', [Validators.required,  Validators.minLength(8), Validators.maxLength(40)]],
  });
  public Constant = Constant;
  currentProfile:any = {};
  isValidated: any;
  reload: boolean = false;
  currentPassword: any;
  password: any;
  confirmPassword: any;
  errors: any = {};
  isSaved = false;
  isHas8Length: boolean = false;
  isHasLetter: boolean = false;
  isHasNonLetter: boolean = false;
  constructor(
    private fb: FormBuilder,
    public user:UserService,
    private accountService: AccountService,
    private customComponentService: CustomComponentService,
    public dataService:DataService,
    private dialog:DialogService,
    public eventManager: EventManagerService,
    private translate:TranslateService,
    private dispatcher: Dispatcher,
    public menuService:MenuService
  ) {

  }

  ngOnInit() {
    this.editForm.get('newPassword').valueChanges.subscribe(
      value => {
        this.disabledButton();
      }
    );
  }
  ngAfterViewInit() {
    ShortcutService.addOneKey(13, this.save.bind(this))
  }

  disabledButton() {
    const password = this.editForm.get('newPassword').value;
    const confirmPassword = this.editForm.get('confirmPassword').value;
    const result1 = (/[a-z]+/g).test(password);
    const result2 = (/[A-Z]+/g).test(password);
    this.isHasLetter = result1 && result2;
    const result3 = (/[^a-zA-Z]+/g).test(password);
    this.isHasNonLetter = result3;
    const result4 = (/^[\w\W]{8,40}$/g).test(password);
    this.isHas8Length = result4;
    // if (password && result1 && result2 && result3 && result4) {
    //   this.errors.invalidPassword = false;
    // } else {
    //   this.errors.invalidPassword = true;
    // }
    if (password && password !== confirmPassword) {
      this.errors.confirmPassword = true;
    } else {
      this.errors.confirmPassword = false;
    }
    
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }

  save() {
    this.isSaved = true;
    const result = this.disabledButton();
    if (result || this.editForm.invalid) {
      return;
    }
    let data = {
      currentPassword: (this.editForm.get('currentPassword').value || '').trim(),
      password: (this.editForm.get('newPassword').value || '').trim(),
      confirmPassword: (this.editForm.get('confirmPassword').value || '').trim()
    }
    this.customComponentService.changePass(data)
      .subscribe(res=>{
        ShortcutService.removeFuncEsc();
        this.dialog.showSuccess(this.translate.instant("success.changePass"), '', {backdrop: 'static'})
        .then(() => {
          this.accountService.logout();
        })
      })
  }
}
